const expandableOpenEvent = new CustomEvent('expandableopen', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const expandableCloseEvent = new CustomEvent('expandableclose', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

export default class Expandable {
    constructor($el) {
        this.el = $el;

        this.isOpen = !this.el.classList.contains('expandable--hide');
    };

    open() {
        if (this.isOpen) return;
    
        this.el.dispatchEvent(expandableOpenEvent);
    
        this.isOpen = true;
        this.el.style.height = '0px';
                            
        window.requestAnimationFrame(() => {
            this.el.classList.remove('expandable--hide');
            this.el.style.height = `${this.el.scrollHeight}px`;
    
            setTimeout(() => {
                this.el.style.height = '';
            }, 500);
        });
    };

    close() {
        if (!this.isOpen) return;
    
        this.el.dispatchEvent(expandableCloseEvent);
    
        this.isOpen = false;
        this.el.style.height = `${this.el.offsetHeight}px`;
    
        window.requestAnimationFrame(() => {
            this.el.classList.add('expandable--hide');
            this.el.style.height = '';
        });
    };

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    };
}
